// Copyright (c) 2016 Deere & Company

import Dealer from '../lib/dealer';
import t from 'tcomb';

const DealerSettingsAccounts = t.struct({
    allowedAccounts: t.list(Dealer),
    registrationAllowedAccounts: t.list(Dealer),
    selectedAccounts: t.list(Dealer)
}, {
    name: 'DealerSettingsAccounts',
    strict: true
});

export const getDefaultState = () => new DealerSettingsAccounts({
    allowedAccounts: [],
    registrationAllowedAccounts: [],
    selectedAccounts: []

});

export default DealerSettingsAccounts;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-settings-accounts.js